export const SET_COLOR = 'options/SET_COLOR'
export const SET_FONT_SIZE = 'options/SET_FONT_SIZE'

export const COLOR_REGULAR = 'COLOR_REGULAR'
export const COLOR_KONTRAST = 'COLOR_KONTRAST'
export const FONT_SIZE_REGULAR = 'FONT_SIZE_REGULAR'
export const FONT_SIZE_BIG = 'FONT_SIZE_BIG'

const initialState = {
    color: COLOR_REGULAR,
    fontSize: FONT_SIZE_REGULAR
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_COLOR:
            return {
                ...state,
                color: action.color
            }
        case SET_FONT_SIZE:
            return {
                ...state,
                fontSize: action.fontSize
            }
        default:
            return state
    }
}

export const setColor = color => {
    return dispatch => {
        dispatch({
            type: SET_COLOR,
            color
        })
    }
}

export const setFontSize = fontSize => {
    return dispatch => {
        dispatch({
            type: SET_FONT_SIZE,
            fontSize
        })
    }
}



// WEBPACK FOOTER //
// ./src/modules/options.js